<mat-card>
  <app-card-header
    [title]="'Asignar ' + data.tipo.toLowerCase()"
    [subtitle]="data.vehiculo.identificacion"
    icono="person_pin"
    [botonCerrar]="true"
    (cerrar)="close()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <section class="inputs-group">
      <ng-select
        [items]="conductores"
        [(ngModel)]="conductorSeleccionado"
        bindLabel="label"
        [placeholder]="data.tipo"
        style="width: 100%"
        [searchable]="true"
        appendTo="body"
        notFoundText="Sin resultados"
        [virtualScroll]="true"
      >
        <ng-template ng-label-tmp let-item="item">
          <span>{{ item.label }}</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="ng-option-content">
            <strong>
              {{ item.datosPersonales?.nombre || item.usuario }}
            </strong>
            @if (item.datosPersonales?.nombre) {
              <small class="ng-option-client">{{ item.usuario }}</small>
            }
          </div>
        </ng-template>
      </ng-select>
    </section>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="close()">Cancelar</button>
    @if (data.vehiculo.vehiculo?.idChofer) {
      <button
        irxBoton="peligro-borde"
        type="button"
        (click)="desasignar()"
      >
        <mat-icon>person_remove</mat-icon>
        Desasignar
      </button>
    }
    <button
      irxBoton="principal"
      type="button"
      [disabled]="!conductorSeleccionado"
      (click)="asignar()"
    >
      <mat-icon>person_add</mat-icon>
      Asignar
    </button>
  </mat-card-actions>
</mat-card>
